import { FarmerFieldsStates } from "@helpers/ui_helper";
import { useQuery } from "@tanstack/react-query";
import { getFields } from "../../services/api";
import AgroMapFarm from "../../features/map/presentation/components/AgroMapFarm";
import { toolbarBaseControls } from "../../features/map/utils/configs";
import { FieldMarkerIcon } from "../../components/map/utils/customs";
import ReactQueryAsyncValueWrapper from "../../shared/components/wrappers/ReactQueryAsyncValueWrapper";

export default function DrawMapPolygon({ setFarmerFieldsState, fieldObject }) {
  const farmerFarmsQuery = useQuery(["fields"], getFields);

  return (
    <ReactQueryAsyncValueWrapper state={farmerFarmsQuery}>
      {(farmerFarms) => {
        return (
          <div className="flex flex-col  gap-6 items-start max-lg:items-center justify-center pt-4">
            <p className="max-lg:hidden text-agrotext font-medium text-right text-base max-lg:text-xs">
              در این قسمت ابتدا محدوده زمین خود را مشخص کرده و سپس بر روی دکمه
              تایید کلیک کنید.
            </p>

            <div className="box-shadow p-2 !rounded-[20px] w-full max-lg:w-[100vw] h-fit">
              <div className="flex inner-circle-neo justify-center items-center overflow-clip !rounded-[20px] max-lg:!rounded-none h-[70vh] w-full max-lg:h-[100%] max-lg:fixed max-lg:top-0 max-lg:left-0 z-[2] max-lg:z-[9999999999]">
                <AgroMapFarm
                  type="add"
                  mapId="2004566"
                  markerIcon={FieldMarkerIcon}
                  toolbarOptions={{
                    ...toolbarBaseControls,
                    drawPolygon: true,
                    editMode: true,
                    removalMode: true,
                  }}
                  currentFarmPolygon={fieldObject.polygon}
                  farmerFarms={farmerFarms.farms}
                  onConfirm={(polygonDetails) => {
                    if (polygonDetails.polygon.length > 0) {
                      setFarmerFieldsState((prev) => ({
                        ...prev,
                        state: FarmerFieldsStates.FieldDetails,
                        fieldObject: {
                          ...fieldObject,
                          polygon: polygonDetails?.polygon,
                          centerCoordinates: polygonDetails?.centerCoordinates,
                          area: polygonDetails?.area,
                        },
                      }));
                    }
                  }}
                  onCancel={() => {
                    setFarmerFieldsState((prev) => ({
                      ...prev,
                      state: FarmerFieldsStates.FieldDetails,
                    }));
                  }}
                />
              </div>
            </div>
          </div>
        );
      }}
    </ReactQueryAsyncValueWrapper>
  );
}
  